<template>
  <div>
    <Modal v-model="modalShow" width="800">
      <p slot="header" class="text-center">小欧预审建议</p>
      <Row :gutter="12">
        <i-col span="12">
          <img
            :src="filePath + '?x-oss-process=image/resize,m_lfit,w_800'"
            style="width: 100%"
          />
        </i-col>
        <i-col span="12">
          <div v-if="result === ''">暂未生成预审建议结果！</div>
          <div v-else>
            <div class="result-content" v-html="result"></div>
          </div>
          <!-- <ai-analysis ref="aiAnalysisRef" :apiUrl="url" :filePath="filePath" /> -->
        </i-col>
      </Row>
    </Modal>
  </div>
</template>

<script>
// import AiSuggestion from '@/components/common/AiSuggestion.vue'
// import AiAnalysis from '@/components/common/AiAnalysis.vue'
import { getAiResult } from '@/api/order/orderfileV2'
export default {
  // components: { AiAnalysis },
  props: {
    filePath: [String],
    fileId: [Number]
  },
  data () {
    return {
      modalShow: false,
      result: ''
      // botId: '7493371949045841959',
      // workflowId: '7496342514505809954',
      // url: '/ooh-ai/v1/workflow/imageReview'
    }
  },
  methods: {
    show () {
      if (this.filePath === '') {
        this.$Notice.error({ desc: '请选择一个文件进行小欧预审' })
        return false
      }
      this.getResult()
      this.modalShow = true
    },
    getResult () {
      this.result = ''
      this.reasoningContent = ''
      getAiResult({ fileId: this.fileId }).then((res) => {
        if (res && res.success) {
          if (res.data && res.data !== '') {
            this.result = res.data
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.result-content{
  padding:0 10px 10px 10px;
  white-space: pre-line;
  line-height: 24px;
  max-height: 480px;
  overflow-y: auto;
}
</style>
